import { NgModule } from '@angular/core';

import { LoginModule } from './login/login.module';
import { SharedModule } from '@shared/shared.module';
import { ErrorPagesModule } from './error-pages/error-pages.module';


@NgModule({
  imports: [
    SharedModule,
    LoginModule,
    ErrorPagesModule
  ]
})
export class PagesModule {}
